//imports
import {
    ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST,
    ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT,
    ACTIVITIES_GET_ACCOUNTS_REQUEST,
    ACTIVITIES_GET_ACCOUNTS_RESULT,
    ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST,
    ACTIVITIES_GET_TSO_ACCOUNTS_RESULT,
    ACTIVITIES_GET_USERS_REQUEST,
    ACTIVITIES_GET_USERS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loadingActivities: false,
    activities: [],
    loadingUsers: false,
    users: [],
    loadingAccounts: false,
    accounts: [],
    nextToken: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST:
            return { ...state, loadingActivities: true }

        case ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT:
            return { 
                ...state, 
                loadingActivities: false,
                activities: action.payload.oldNextToken 
                ? [...state.activities , ...action.payload.activities ] 
                : action.payload.activities,
                nextToken: action?.payload?.nextToken }

        case ACTIVITIES_GET_ACCOUNTS_REQUEST:
            return { ...state, loadingAccounts: true }

        case ACTIVITIES_GET_ACCOUNTS_RESULT:
            return { ...state, loadingAccounts: false, accounts: action.payload }

        case ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST:
            return { ...state, loadingTSOAccounts: true }

        case ACTIVITIES_GET_TSO_ACCOUNTS_RESULT:
            return { ...state, loadingTSOAccounts: false, TSOAccounts: action.payload }

        case ACTIVITIES_GET_USERS_REQUEST:
            return { ...state, loadingUsers: true }

        case ACTIVITIES_GET_USERS_RESULT:
            return { ...state, loadingUsers: false, users: action?.payload?.users || [] }

        case CLEAR_REDUX:
            return ["", "ACTIVITIES_MAIN"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};